import CommentIcon from "modules/Main/components/icon/CommentIcon";
// import LikeIcon from "modules/Main/components/icon/LikeIcon";
import Image from "../Image";
import { memo } from "react";
import CGallery from "../CGallery";
import CShareCommunity from "../CShareCommunity";
import CLikeCommunity from "../CLikeCommunity";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName } from "core/router";
import { useSearchParams } from "react-router-dom";
import PostShared from "modules/Community/components/CommunityForm/PostShared";
import { getYouTubeThumbnail, handleMapShortContent } from '../../utils/helper';
import CCommentIcon from "../CCommentIcon";
import { useGoToRecipeDetail } from "modules/Recipes/hooks/recipe";
import { IRecipeDetail } from "modules/Recipes/store/types";
import Icon from "core/assets/icons";
interface CPostItemProps {
  thumbnail: string;
  title: string;
  likeCount: number;
  commentCount: number;
  type?: "thumbnail" | "original";
  isGallery?: boolean;
  handleClick?: () => void;
  shareCount?: number;
  actionReactive?: boolean;
  id?: number;
  item?: any;
  isDetail?: boolean;
  handleClickComment?: (e: any) => void;
}
const CPostItem = ({
  thumbnail,
  title,
  likeCount,
  commentCount,
  type = "thumbnail",
  shareCount,
  handleClick,
  actionReactive = false,
  id,
  item,
  isDetail = false,
  handleClickComment, 
}: CPostItemProps) => {
  const [searchParams] = useSearchParams();
  const navigate = useCustomNavigate();
  const goToDetail = useGoToRecipeDetail(RouterName.INGREDIENT_RECIPE_DETAIL)
  const tab = searchParams.get("tab") || "trending";
  const _handleClick = () => {
    navigate(`${RouterName.POST_DETAIL.replace(":id", id)}?tab=${tab}`);
    handleClick?.();
  };
  const handleMapItemGallery = () => {
    const gallerys = item?.files.map((item: any) => {
      return {
        src: item?.url?.original,
        thumbnail: item?.url?.medium || item?.url?.thumbnail,
        type: item?.mime_type.includes("image") ? "image" : "video",
      };
    });
    return gallerys || [];
  };

  const getThumbnail = () => {
    const galleryItems = handleMapItemGallery();
    if (galleryItems.length > 0){
      const videoThumbnail = galleryItems.find((item: any) => item?.type === "video")?.thumbnail;
      return videoThumbnail || galleryItems[0]?.thumbnail;
    }
    if (item?.recipe?.video_id) {
      return getYouTubeThumbnail(item?.recipe?.video_id);
    }
    if (item?.shared_post?.id) {
      const files = item.shared_post.files || [];
      const videoFile = files.find((file: any) => file.mime_type?.includes("video"));
      return videoFile?.url?.thumbnail ?? files[0]?.url?.thumbnail;
    }
    return thumbnail;
  }


  const _handleClickComment = (e: any) => {
    handleClickComment?.(e);
  }

  const _handleClickItemShare = (data: any) => {
    if(!isDetail) return
    console.log('handleClickItemShare', data)
    if(data.typePost === 'recipe'){
      goToDetail({
            id: data?.id || '',
            name: data?.name || '',
            thumbnail: data?.youtube_videos?.[0]?.thumbnail || '',
      } as IRecipeDetail);
    }
    if(data.typePost === 'community'){
      navigate(`${RouterName.POST_DETAIL.replace(":id", data.id)}`);
    }
  }

  const dataTitle = handleMapShortContent(item,(!isDetail ? 150 : 2000));

  return (
    <div className="w-full mt-2" onClick={() => _handleClick()}>
      {type === "thumbnail" && (
        <div>
          <div className="py-2 h-[100px] ">
            <Image
              src={getThumbnail()}
              alt={title}
              className="w-full h-full rounded-[8px]"
              
            />
          </div>

          <div className="">
            <h3
              className="text-[#333333] text-[13px] 
            font-normal line-clamp-2 h-[38px] overflow-hidden
            "
            dangerouslySetInnerHTML={{__html: (dataTitle)}}
            />
          </div>
          <div className="flex items-center justify-items-start mt-2">
            <div className="flex items-center gap-1">
              <img className="mr-[5px]" src={item?.user_reaction ? Icon.HeartActive : Icon.Heart} alt={'favorite'} />
              <span className="text-[#777777] text-[11px] justify-center pb-[2px]">
                {likeCount}
              </span>
            </div>
            <div className="flex items-center gap-1 ml-2">
              <CommentIcon />
              <span className="text-[#777777] text-[11px] justify-center pb-[2px]">
                {commentCount}
              </span>
            </div>
          </div>
        </div>
      )}
      {type === "original" && (
        <div>
          <div className="">
            <h3
              className="text-[#111111] text-[15px] font-normal 
             overflow-hidden
            "
            dangerouslySetInnerHTML={{__html: (dataTitle)}}
            >
            </h3>
          </div>
          {item?.recipe && <PostShared isRemove={false} postType={'recipe'} post={item?.recipe} handleClick={_handleClickItemShare} onRemovePost={()=>{}} /> }
          {item?.shared_post && <PostShared isRemove={false} postType={'community'} post={item?.shared_post} handleClick={_handleClickItemShare} onRemovePost={()=>{}} /> }
          <div className="py-2">
            {handleMapItemGallery().length > 0 ? (
              <CGallery className="" items={handleMapItemGallery()} />
            ) : thumbnail ? (
              <Image
                src={thumbnail}
                alt={title}
                className="h-[200px] object-cover rounded-[8px] w-full"
              />
            ) : (
              ""
            )}
          </div>
          <div
            className={`flex items-center justify-items-start mt-2 ${
              !actionReactive ? " pointer-events-none" : ""
            }`}
          >
            <CLikeCommunity  className="mr-[17px]" tab={tab} type={"post"} id={id} countLike={likeCount} active={item?.user_reaction} />
            <CCommentIcon id={id} commentCount={commentCount} handleClickComment={_handleClickComment}  className="mr-[17px]" />
            <CShareCommunity
              dataCount={shareCount}
              className="mr-[15px]"
              id={Number(id)}
              item={item}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(CPostItem);
